const CipherPalette = {
  background: '#DCDBDC',
  cabaretL0: '#DA4D61',
  cabaretL3: '#FEF1F3',
  cipherGreenL0: '#00BEAA',
  cipherPurpleL0: '#852F8B',
  darkGrayL0: '#4B4F54',
  jellyBeanL0: '#2974A8', // Deep Blue
  jellyBeanL2: '#94B9D3', // Soft Gray Blue
  lightGray: '#f5f5f5',
  medGrayL0: '#979797',
  medGrayL1: '#EDF1F7',
  medGrayL2: '#787878',
  medGrayL3: '#8D959E',
  medGrayL4: '#777777',
  tundoraL0: '#444444',
  tundoraL1: '#B0B0B0',
  tundoraL2: '#D9D9D9',
  tundoraL3: '#F7F7F7',
  whiteL0: '#FFF',
  transparent: '#00000000',
};

export const CipherColorVariables = {
  primary: CipherPalette.jellyBeanL0,
  secondary: CipherPalette.tundoraL0,
  background: CipherPalette.background,
  default: CipherPalette.tundoraL2,
  error: CipherPalette.cabaretL0,
  errorBorder: CipherPalette.cabaretL3,
  header: CipherPalette.jellyBeanL2,
  icon: CipherPalette.cipherGreenL0,
  text: CipherPalette.tundoraL0,
};

export const COLORS = { ...CipherPalette, ...CipherColorVariables };
